import { createContext } from "react";

type LnaPermissionState =
  | "unknown"
  | "granted"
  | "prompt"
  | "denied"
  | "unsupported";

type LocalNetworkAccessContextValue = {
  permissionState: LnaPermissionState;
  /** Resolves when permission is granted. Rejects if denied/dismissed. */
  ensurePermission: () => Promise<void>;
};

const LocalNetworkAccessContext =
  createContext<LocalNetworkAccessContextValue | null>(null);

export { LocalNetworkAccessContext };
export type { LocalNetworkAccessContextValue, LnaPermissionState };
